import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { DataTransferService } from '../../../../../services/DataTransferService';
import { debug } from 'console';



@Component({
  selector: "receipt-table",
  templateUrl: "./receipt-table.component.html",
  styleUrls: ["./receipt-table.component.scss"],
})
export class ReceiptTableComponent implements OnInit {
  localShipmentsByCurrencyOB = {};
  localShipmentsByCurrencyIB = {};
  localShipmentsByCurrencyPackaging = {};
  localShipmentsByCurrencyDO = {};
  @Input() shippments;

  @Input() shipmentsByCurrency;
  @Output() newShippmentRequest = new EventEmitter();
  @Output() checkout = new EventEmitter();
  @Output() deleteShipment = new EventEmitter();
  @Output() changeDiscount = new EventEmitter();
  @Output() duplicateShipment = new EventEmitter();
  allowDiscountOutbound = false;
  allowDiscountInbound = false;
  EnableCurrencyDeduction = "False";
  localEntity: string;
  branchCurrencyCode: string = JSON.parse(sessionStorage.getItem('company')).BranchCurrencyCode;

  constructor(
    private router: Router,
    private dataTransfer: DataTransferService
  ) {
    this.allowDiscountOutbound = JSON.parse(
      sessionStorage.getItem("user")
    ).Settings.DiscountEnabledOnOutbound;
    this.allowDiscountInbound = JSON.parse(
      sessionStorage.getItem("user")
    ).Settings.DiscountEnabledOnInbound;
    this.EnableCurrencyDeduction =
      JSON.parse(sessionStorage.getItem("branchSettings")).filter(
        (x) => x.Key == 33
      )[0] != undefined
        ? JSON.parse(sessionStorage.getItem("branchSettings")).filter(
            (x) => x.Key == 33
          )[0].Value
        : "False";
  }

  ngOnInit() {
    this.updateAllShipmentsBasedOnCode();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.shipmentsByCurrency.previousValue != changes.shipmentsByCurrency.currentValue) {
      this.updateAllShipmentsBasedOnCode();
    }
  }


  getLocalData(){
   this.localEntity = sessionStorage.getItem('company')
  }
  showDiscount(index) {
    this.shippments[index].discount.isLocked = false;
  }
  newReceipt() {
    this.dataTransfer.changeMode("default message");
    this.dataTransfer.changeCountry("default message");
    this.dataTransfer.changeProductGroup("default message");
    this.dataTransfer.changeProductType("default message");
  }
  addShippment() {
    this.newReceipt();
    this.newShippmentRequest.emit(true);
  }

  findTotal(mode, typeOf, of) {
    
    var total = 0;
    if (typeOf == "Amount") {
      this.shippments[mode].forEach((item) => {
        try {
          if (item[typeOf] != null && item[typeOf] != undefined) {
            var c = item[typeOf];
            total += Number(c);
          }
        } catch (ex) {}
      });
    } else {
      this.shippments[mode].forEach((item) => {
        try {
          if (
            item["Shipment"][typeOf][of] != null &&
            item["Shipment"][typeOf][of] != undefined
          ) {
            var c = item["Shipment"][typeOf][of];
            total += Number(c);
          }
        } catch (ex) {}
      });
    }
    return Number(total);
  }
  onDiscountApplied(discount, index, type) {
    if (type == "outbound") {
      if (
        this.shippments[type][index].Shipment.GrandTotal &&
        this.shippments[type][index].Shipment.GrandTotal.Value > 0
      ) {
        this.shippments[type][index].Shipment.GrandTotal.Value =
          this.shippments[type][index].Shipment.GrandTotal.Value -
          discount.DiscountAmount;
        //testing only
        // var temp = ((this.shippments[type][index].Shipment.RatedPrice.Value + this.shippments[type][index].Shipment.TotalCharges.Value) - discount.DiscountAmount) * this.shippments[type][index].Shipment.ShipperAccountTaxRate;
        //  this.shippments[type][index].Shipment.TaxAmount.Value = (this.EnableCurrencyDeduction == "True" && this.shippments[type][index].Shipment.ProductGroup == "EXP") ? (this.shippments[type][index].Shipment.ShipperAccountTaxRate*100) : (((this.shippments[type][index].Shipment.RatedPrice.Value + this.shippments[type][index].Shipment.TotalCharges.Value) - discount.DiscountAmount) * this.shippments[type][index].Shipment.ShipperAccountTaxRate);
        if (
          this.EnableCurrencyDeduction == "True" &&
          this.shippments[type][index].Shipment.ProductGroup == "EXP"
        ) {
          this.shippments[type][index].Shipment.TaxAmount.Value = this.shippments[type][index].Shipment.TaxAmount.Value;
        } else {
          this.shippments[type][index].Shipment.TaxAmount.Value =
            (this.shippments[type][index].Shipment.RatedPrice.Value +
              this.shippments[type][index].Shipment.TotalCharges.Value -
              discount.DiscountAmount) *
            this.shippments[type][index].Shipment.ShipperAccountTaxRate;
        }
      }
    } else if (type == "inbound") {
      if (this.shippments[type][index].Shipment.GrandTotal) {
        this.shippments[type][index].Shipment.TaxAmount.Value =
          this.fixDecimals(
            (this.shippments[type][index].Shipment.RatedPrice.Value -
              discount.DiscountAmount) *
              this.shippments[type][index].Shipment.ShipperAccountTaxRate
          );
        this.shippments[type][index].Shipment.GrandTotal.Value =
          this.fixDecimals(
            this.shippments[type][index].Shipment.RatedPrice.Value +
              (this.shippments[type][index].Shipment.CustomsCharges !== null
                ? this.shippments[type][index].Shipment.CustomsCharges
                : 0) +
              this.shippments[type][index].Shipment.CashOnDelivery.Value -
              discount.DiscountAmount +
              this.shippments[type][index].Shipment.TaxAmount.Value
          );
      }
    } else if (type == "dropoff") {
      if (
        this.shippments[type][index].Shipment.GrandTotal &&
        this.shippments[type][index].Shipment.GrandTotal.Value > 0
      ) {
        this.shippments[type][index].Shipment.GrandTotal.Value =
          this.shippments[type][index].Shipment.GrandTotal.Value -
          discount.DiscountAmount;

        if (
          this.EnableCurrencyDeduction == "True" &&
          this.shippments[type][index].Shipment.ProductGroup == "EXP"
        ) {
          this.shippments[type][index].Shipment.TaxAmount.Value = this.shippments[type][index].Shipment.TaxAmount.Value;
        } else {
          this.shippments[type][index].Shipment.TaxAmount.Value =
            (this.shippments[type][index].Shipment.RatedPrice.Value - discount.DiscountAmount) *
            this.shippments[type][index].Shipment.ShipperAccountTaxRate;
        }
      }
    }

    this.shippments[type][index].Amount = discount.Amount; //Number(discount.Amount) + Number(this.shippments[type][index].Shipment.TaxAmount.Value);
    this.shippments[type][index].DiscountAmount = this.fixDecimals(
      discount.DiscountAmount
    );
    this.shippments[type][index].DiscountComments = discount.DiscountComments;
    this.shippments[type][index].DiscountValue = discount.DiscountValue;
    this.shippments[type][index].DiscountValueBy = discount.DiscountValueBy;
    this.changeDiscount.emit({
      number: this.shippments[type][index].Shipment.Number,
      type: type,
      discount: this.shippments[type][index].DiscountAmount,
      comments: this.shippments[type][index].DiscountComments,
      currency: discount.currency,
      discountValue: discount.DiscountValue,
      discountValueBy: discount.DiscountValueBy,
    });
  }
  isThereShippments() {
    try {
      if (
        this.shippments.outbound.length == 0 &&
        this.shippments.inbound.length == 0 &&
        this.shippments.misc.length == 0 &&
        this.shippments.dropoff.length == 0 &&
        this.shippments.Packaging.length == 0
      )
        return false;
      else return true;
    } catch (e) {
      return false;
    }
  }
  removeShipment(type, index, code = undefined) {
    var number = this.shippments[type][index].Shipment.Number;
    this.shippments[type].splice(index, 1)
    this.updateAllShipmentsBasedOnCode();
    this.deleteShipment.emit({ number: number, type: type, code: code })
  }

  onDuplicateShipment(data, code) {
    this.duplicateShipment.emit({ data, code });
  }

  getAllCurrency() {
    return Object.keys(this.shipmentsByCurrency);
  }

  updateAllShipmentsBasedOnCode() {
    Object.keys(this.shipmentsByCurrency).map((code) => {
      console.log('this is code', code);
      
      this.localShipmentsByCurrencyOB[code] = this.getAllShipmentsBasedOnCode(code, 'outbound');
      this.localShipmentsByCurrencyIB[code] = this.getAllShipmentsBasedOnCode(code, 'inbound');
      this.localShipmentsByCurrencyDO[code] = this.getAllShipmentsBasedOnCode(code, 'dropoff');
      this.localShipmentsByCurrencyPackaging[code] = this.getAllShipmentsBasedOnCode(code, 'Packaging');
      
    });
  }

  getAllShipmentsBasedOnCode(currencyCode: string, type: string) {
    const allAWBCodes = Array.from(this.shipmentsByCurrency[currencyCode]).filter((x: any) => x.type.toLowerCase() == type.toLowerCase()).map((x: any) => x.shipmentNo);
    console.log(this.shippments);
    
    
    const returnValue = [];
    
    this.shippments[type].forEach((item: any, index: number) => {
      let result = allAWBCodes.includes(item.Shipment.Number);

      if(type == 'inbound') {
        if (currencyCode != this.getCurrency(item)) {
          result = false;
        }
      }

      if(result) {
        returnValue.push({
          data: item,
          index: index
        })
      }
    });
    return returnValue;
  }

  checkCurrency(currency: string) {
    return currency != null && currency.trim() != ''
  }

  getCurrency(shipment) {
    if (this.checkCurrency(shipment.Shipment.CashOnDelivery.Code) && shipment.Shipment.CashOnDelivery.Value != 0) {
      return shipment.Shipment.CashOnDelivery.Code;
    } else  if (this.checkCurrency(shipment.Shipment.Customs.Code) && shipment.Shipment.Customs.Value != 0) {
      return shipment.Shipment.Customs.Code;
    } else if (this.checkCurrency(shipment.Shipment.RatedPrice.Code) && shipment.Shipment.RatedPrice.Value != 0) {
      return shipment.Shipment.RatedPrice.Code;
    }
    return this.branchCurrencyCode;
  }

  getTotalBasedOnCode(currencyCode: string, type: string) {
    const allAWBCodes = Array.from(this.shipmentsByCurrency[currencyCode]).filter((x: any) => x.type.toLowerCase() == type.toLowerCase()).map((x: any) => x.shipmentNo);
    var total = 0;
    this.shippments[type].forEach((item: any, index: number) => {
      let result = allAWBCodes.includes(item.Shipment.Number);

      if(type == 'inbound') {
        if (currencyCode != this.getCurrency(item)) {
          result = false;
        }
        if(result) {
          total = (total + this.findVerticalTotal(type, index));
        }
      } else if(result) {
        total = (total + parseFloat(item.Amount));        
      }

    });
    return total;
  }

  next() {
    this.checkout.emit(this.shippments);
  }
  findVerticalTotal(type, index) {
    this.shippments[type][index].Shipment.CashOnDelivery.Value =
      this.shippments[type][index].Shipment.CashOnDelivery.Value == undefined
        ? 0
        : this.shippments[type][index].Shipment.CashOnDelivery.Value;
    this.shippments[type][index].Shipment.RatedPrice.Value =
      this.shippments[type][index].Shipment.CashOnDelivery.Value == undefined
        ? 0
        : this.shippments[type][index].Shipment.RatedPrice.Value;
    return (
      Number(this.shippments[type][index].Shipment.Customs.Value) +
      Number(this.shippments[type][index].Shipment.CashOnDelivery.Value) +
      Number(this.shippments[type][index].Shipment.RatedPrice.Value) +
      Number(this.shippments[type][index].Shipment.TaxAmount.Value)
    );
  }
  findAllTotal(type) {
    var total = 0;
    var index = 0;
    if (type == "outbound") {
      while (index < this.shippments[type].length) {
        total = total + parseFloat(this.shippments[type][index].Amount);
        index++;
      }
    } else {
      while (index < this.shippments[type].length) {
        total = total + this.findVerticalTotal(type, index);
        index++;
      }
    }
    return total;
  }
  fixDecimals(value: any = 0) {
    if (value != 0 && value != null) {
      value = parseFloat(value).toFixed(2);
      return value;
    } else {
      if (value || value == 0) return "0.00";
      else return "";
    }
  }
}
